import React from 'react'
import { EligibilityContextProvider } from '../../../context/EligibilityContext'
import { FormContextProvider } from '../../../context/formContext'
import ElegibilidadForm from './Elegibilidad'
import Toast from '../../../components/Toast/Toast'
import { ElegibilidadProvider } from '../../../context/ElegibilidadContext'
const FormElegibilidad = () => {
  return (
    <EligibilityContextProvider>
      <FormContextProvider>
        <ElegibilidadProvider>
          <ElegibilidadForm />
          <Toast />
        </ElegibilidadProvider>
      </FormContextProvider>
    </EligibilityContextProvider>
  )
}

export default FormElegibilidad
